import React from 'react';
import { sendEvent } from '../../../../client/analytics/dataLayerService';

/*
 * Component to flag users as having participated in an A/B test.
 *
 * Google Tag Manager will find any ab-identifier divs on the page and append their values
 * to the user's ab_identifier tag. This will be passed along to Amplitude's Identify API for
 * later tracking.
 * 
 * The tag manager snippet looks like this:
    document.querySelectorAll('.ABIdentifier').forEach(elem => {
        var tag = elem.getAttribute("data-tag");
        identify.postInsert('ab_identifier', tag);
    });
 */

var EVENT_NAME = 'experiment_viewed';
export var sendABExperimentEvents = function sendABExperimentEvents() {
  // We don't expect there to be more than 1 on a given page but we'll account for the possibility
  document.querySelectorAll('.ABIdentifier').forEach(function (elem) {
    var data = {
      experiment_id: elem.getAttribute('data-experiment-id'),
      variation_id: elem.getAttribute('data-variation-id')
    };
    sendEvent(EVENT_NAME, data);
  });
};
export var ABIdentifier = function ABIdentifier(_ref) {
  var variationId = _ref.variationId,
    experimentId = _ref.experimentId;
  return /*#__PURE__*/React.createElement("div", {
    className: "ABIdentifier",
    "data-experiment-id": experimentId,
    "data-variation-id": variationId
  });
};